import { shallowRef } from 'vue';
export const INPUT_HOSTS = Symbol('player-input-hosts');
export function createInputHosts() {
    const target = shallowRef();
    return {
        target,
        register(host) {
            target.value = host;
        },
        unregister(host) {
            if (target.value === host) {
                target.value = undefined;
            }
        },
    };
}
